import { isCommercialProjectRow } from "./commercialProjectAcf";

export function workOrderBaseForCommercialRow(row) {
  const wo = String(row?.work_order ?? "").trim();
  if (row?.work_order_base != null && String(row.work_order_base).trim() !== "") {
    return String(row.work_order_base).trim();
  }
  return wo.includes(".") ? wo.split(".")[0] : wo;
}

export function isCommercialSubWorkOrderRow(row) {
  const wo = String(row?.work_order ?? "").trim();
  return Boolean(wo && wo.includes("."));
}

/** Count decimal sub-work orders per parent base from a project list. */
export function buildSubWorkOrderCountByBase(rows) {
  const counts = {};
  for (const row of rows || []) {
    if (!isCommercialProjectRow(row)) continue;
    if (!isCommercialSubWorkOrderRow(row)) continue;
    const base = workOrderBaseForCommercialRow(row);
    if (!base) continue;
    counts[base] = (counts[base] || 0) + 1;
  }
  return counts;
}

/** Parent WO rows that use the work-order group page instead of a project landing page. */
export function isCommercialWorkOrderGroupParent(row, subWorkOrderCountByBase) {
  if (!isCommercialProjectRow(row)) return false;
  if (isCommercialSubWorkOrderRow(row)) return false;
  const wo = String(row?.work_order ?? "").trim();
  if (!wo) return false;
  const childCount = Math.max(
    Number(row?.sub_work_order_count ?? 0) || 0,
    Number(subWorkOrderCountByBase?.[wo] ?? 0) || 0
  );
  return row.multisite === true || childCount > 0;
}

export function commercialWorkOrderGroupPath(row, subWorkOrderCountByBase) {
  if (!isCommercialWorkOrderGroupParent(row, subWorkOrderCountByBase)) return null;
  return `/work-order/${String(row.work_order).trim()}`;
}
